import { UploadFileToFirebase } from '@/libs'

import {
    COMPONENT_DEFAULT_ERRORS,
    COMPONENT_DEFAULT_FORM,
    COMPONENT_DEFUALT_FILTERS,
    ENDPOINTS
} from '@/data'

import {
    CategoryValidation,
    ClipboardValidation,
    ImageValidation,
    LinkValidation,
    NameValidation,
    PriceValidation,
    Request,
    TagsValidation,
    VideoValidation
} from '@/helpers'

const Create = async (props: ClientComponentCreateFunctionProps) => {
    const {
        Form,
        Errors,
        SetComponentState,
        SetState,
        InitNotification
    } = props

    try {
        const {
            Name,
            Category,
            Tags,
            Link,
            Image,
            Clipboard,
            Price,
            Video
        } = Form

        const clone_errors = structuredClone(Errors)
        Object.keys(clone_errors).forEach(key => { clone_errors[key] = true })

        SetState({ Errors: clone_errors })

        const nameIsValid = NameValidation(Name)
        const priceIsValid = PriceValidation(Price)
        const categoryIsValid = CategoryValidation(Category)
        const tagsAreValid = TagsValidation()
        const linkIsValid = LinkValidation(Link)
        const imageIsValid = ImageValidation(Image)
        const videoIsValid = VideoValidation(Video)
        const clipboardIsValid = ClipboardValidation(Clipboard)

        const isValid =
            !nameIsValid.error &&
            !priceIsValid.error &&
            !linkIsValid.error &&
            !imageIsValid.error &&
            !tagsAreValid.error &&
            !categoryIsValid.error &&
            !clipboardIsValid.error &&
            !videoIsValid.error

        if (isValid) {
            SetState({ Loading: true })

            const sideover_panel = document.querySelector('#sideover-panel')

            if (sideover_panel) sideover_panel.scrollBy({
                top: -sideover_panel.scrollHeight,
                behavior: 'smooth'
            })

            const image_url = await UploadFileToFirebase(Image, '/images/')
            const video_url = await UploadFileToFirebase(Video, '/videos/')

            if (image_url && video_url) {
                const { success, message } = await Request({
                    path: ENDPOINTS.CREATE_COMPONENT,
                    method: 'POST',
                    body: {
                        Name,
                        Category,
                        Price,
                        Tags,
                        Link,
                        Video: video_url,
                        Image: image_url,
                        Clipboard
                    }
                })

                if (success) {
                    SetComponentState({
                        Filters: {
                            ...COMPONENT_DEFUALT_FILTERS,
                            random: Math.random() + Date.now()
                        }
                    })

                    const components_panel = document.querySelector('#component-list')

                    if (components_panel) components_panel.scrollBy({
                        top: -components_panel.scrollHeight,
                        behavior: 'smooth'
                    })

                    InitNotification(message)

                    SetState({
                        Form: COMPONENT_DEFAULT_FORM,
                        Errors: COMPONENT_DEFAULT_ERRORS,
                        Loading: false
                    })
                }

                else {
                    InitNotification(message)
                    SetState({ Loading: false })
                }
            }

            else {
                InitNotification('Image didn\'t uploaded, so we canceled the process of creating component!')
                SetState({ Loading: false })
            }
        }
    }

    catch (error) {
        console.error(error)

        InitNotification('Something went wrong while trying to create component, please try again!')
        SetState({ Loading: false })
    }
}

export default Create
